module.exports = __webpack_public_path__ + "static/media/chat_bot.2894b90c.svg";